module.exports = __webpack_public_path__ + "img/img-pragmaticplay.6b5b64d9.png";